module.exports = __webpack_public_path__ + "img/paysafecard.bd560e13.png";